// src/hooks/useAvailableModels.js
// Fetches built-in model catalog from DB via /api/llm-catalog
// Falls back to a minimal hardcoded list on error.
import { useState, useEffect } from 'react';
import { customModelService } from '../services/customModelService';
import { API_CONFIG } from '../config/api';

const FALLBACK_MODELS = [
  { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5', provider: 'Anthropic' },
];

export function useAvailableModels() {
  const [models, setModels] = useState(FALLBACK_MODELS);

  useEffect(() => {
    const token = localStorage.getItem('token');

    // Load catalog immediately — show as soon as it arrives
    fetch(`${API_CONFIG.BASE_URL}/api/llm-catalog`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : [])
      .then(catalog => {
        const builtIn = (catalog || []).map(m => ({
          value:           m.model_id,
          label:           m.name,
          provider:        m.provider,
          badge:           m.badge,
          requiredPlan:    m.required_plan,
          inputCostPer1k:  m.input_cost_per_1k,
          outputCostPer1k: m.output_cost_per_1k,
          supportsVision:  m.supports_vision ?? false,
        }));
        if (builtIn.length > 0) setModels(builtIn);
      })
      .catch(() => {});

    // Load custom models independently — append when ready
    customModelService.list()
      .then(custom => {
        const customItems = (custom || [])
          .filter(m => m.is_active)
          .map(m => ({
            value:    m.name,
            label:    m.name,
            provider: 'Custom',
            isCustom: true,
          }));
        if (customItems.length > 0)
          setModels(prev => [...prev, ...customItems]);
      })
      .catch(() => {});
  }, []);

  return models;
}
